/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiSettingsAdd } from '../models/AiSettingsAdd';
import type { AiSettingsResponse } from '../models/AiSettingsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AiSettingsService {
    /**
     * History added ai settings
     * History added ai settings order by created at
     * @returns any successful operation
     * @throws ApiError
     */
    public static getAiSettingsHistory(): CancelablePromise<{
        items?: Array<AiSettingsResponse>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ai_settings',
        });
    }
    /**
     * Add new settings
     * You can add new prompt and temperature for ai service
     * @param requestBody Add ai_settings
     * @returns AiSettingsResponse successful operation
     * @throws ApiError
     */
    public static addAiSettings(
        requestBody?: AiSettingsAdd,
    ): CancelablePromise<AiSettingsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ai_settings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
